import { render, staticRenderFns } from "./ContainerHome.vue?vue&type=template&id=52ac6d7e&scoped=true&"
import script from "./ContainerHome.vue?vue&type=script&lang=js&"
export * from "./ContainerHome.vue?vue&type=script&lang=js&"
import style0 from "./ContainerHome.vue?vue&type=style&index=0&id=52ac6d7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ac6d7e",
  null
  
)

export default component.exports